export const normalizeExpenseFeeSupplierContributorOptions = (items = []) => {
  return (Array.isArray(items) ? items : [])
    .map((item) => {
      const contributorId = Number(item?.id || 0);
      const rfc = String(item?.rfc || '').trim().toUpperCase();
      const name = String(item?.name || item?.business_name || '').trim();

      if (contributorId <= 0 || rfc === '' || name === '') {
        return null;
      }

      return {
        value: contributorId,
        label: `${rfc} - ${name}`,
        meta: {
          ...item,
          rfc,
          name,
        },
      };
    })
    .filter(Boolean)
    .sort((left, right) => String(left.label).localeCompare(String(right.label), 'es'));
};

export const buildExpenseFeeClassFromSupplier = (supplierOption) => {
  const classId = Number(supplierOption?.meta?.class_id || 0);

  if (classId <= 0) {
    return null;
  }

  return {
    value: classId,
    label: String(supplierOption?.meta?.class_name || '').trim() || `Clase ${classId}`,
    meta: {
      id: classId,
      name: String(supplierOption?.meta?.class_name || '').trim(),
    },
  };
};

export const buildExpenseFeeCategoryFromSupplier = (supplierOption) => {
  const categoryId = Number(supplierOption?.meta?.category_id || 0);

  if (categoryId <= 0) {
    return null;
  }

  return {
    value: categoryId,
    label: String(supplierOption?.meta?.category_name || '').trim() || `Categoría ${categoryId}`,
    meta: {
      id: categoryId,
      name: String(supplierOption?.meta?.category_name || '').trim(),
    },
  };
};

export const buildExpenseFeeCreatedSupplierOption = ({
  supplier,
  fallbackName = '',
  classId = 0,
  categoryId = 0,
  classLabel = '',
  categoryLabel = '',
}) => {
  return {
    value: Number(supplier?.id || 0),
    label: String(supplier?.name || fallbackName).trim(),
    meta: {
      ...supplier,
      class_id: classId,
      category_id: categoryId,
      class_name: String(classLabel || '').trim(),
      category_name: String(categoryLabel || '').trim(),
      name: String(supplier?.name || fallbackName).trim(),
    },
  };
};
